/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from '@emotion/core';
import IconButton from '~components/_common/IconButton/IconButton';
import { NavIcon } from '~components/_common/NavIcon/NavIcon';
import { StateDataNode } from '../LeftSideView';
import ModuleTender from '~src/assets/nav-icons/module-tender-hammer-color.svg';
import { EStyleObj } from '~src/types';
import { LoadSharedSubfolderFoldersParams } from '~src/services/api/shares';
import { BaseHomeNavigationKeys } from '~src/data/navigationItems';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export type HomeMenuStateDataNode = StateDataNode<
  Partial<LoadSharedSubfolderFoldersParams>
>;

export const useDefaultHomeLeftNavigationItems: (
  styles: EStyleObj
) => HomeMenuStateDataNode[] = (styles) => {
  const intl = useIntl();
  const navigationItems = useMemo(
    () => [
      {
        title: intl.formatMessage({ id: 'public-tenders' }),
        path: '/public-tenders',
        key: BaseHomeNavigationKeys.CACHED_PUBLIC_TENDERS,
        parentId: 'home',
        icon: (
          <IconButton
            customStyle={styles.icons}
            color="green"
            backgroundOff
            icon={['fad', 'share-alt-square']}
          />
        ),
        children: [],
        isLeaf: false,
      },
      {
        title: intl.formatMessage({ id: 'cached-shares' }),
        path: '/invitations',
        key: BaseHomeNavigationKeys.CACHED_SHARES,
        parentId: 'home',
        icon: (
          <IconButton
            customStyle={styles.icons}
            color="yellow"
            backgroundOff
            icon={['fad', 'share-alt-square']}
          />
        ),
        children: [],
        isLeaf: false,
      },
      {
        title: intl.formatMessage({ id: 'projectweb' }),
        path: '/my-projects',
        key: BaseHomeNavigationKeys.PROJECTWEB,
        parentId: 'home',
        icon: (
          <IconButton
            icon={['fad', 'house']}
            customStyle={styles.icons}
            backgroundOff
          />
        ),
        children: [],
        isLeaf: false,
      },
      {
        title: intl.formatMessage({ id: 'my-tender' }),
        path: '/my-tenders',
        key: BaseHomeNavigationKeys.MY_TENDERS,
        parentId: 'home',
        icon: (
          <NavIcon
            customStyle={{
              marginLeft: '-8px',
              width: '120%',
              height: '75%',
            }}
            icon={ModuleTender}
          />
        ),
        children: [],
        isLeaf: true,
      },
    ],
    [styles]
  );
  return navigationItems;
};
